export default {
  publishEvent: function(eventName, eventData){
    // new event
    const event = new CustomEvent(eventName, {
      detail: eventData,
      bubbles: true
    });
    document.dispatchEvent(event);
  },

  subscribeToEvent: function(eventName, callback){
    document.addEventListener(eventName, function(e) { callback(e.detail); });
  }
};
